'use client';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { digitalWallets } from '../../app/types/digitalWallets.types';
import { acceptedPaymentMethod } from '../../types/customer.types';

export type SelectedPaymentMethodType =
  | 'credit_card'
  | 'pix'
  | 'boleto'
  | digitalWallets;

const renderablePaymentMethods = ['credit_card', 'pix', 'boleto'] as const;

function resolveSelectedMethod(
  paymentMethod: acceptedPaymentMethod,
  selectedDigitalWallet: digitalWallets | null
): SelectedPaymentMethodType | null {
  if (selectedDigitalWallet) return selectedDigitalWallet;
  
  return (
    renderablePaymentMethods.find((method) => method === paymentMethod) ?? null
  );
}

export function useSelectedPaymentMethod() {
  const {
    paymentMethod,
    selectedDigitalWallet,
    setPaymentMethod,
    setSelectedDigitalWallet,
    setPaymentWithClickToPay,
    isCustomerFormLoading,
  } = usePaymentMethod();

  const selectedMethod = resolveSelectedMethod(
    paymentMethod,
    selectedDigitalWallet
  );

  const clearSelection = () => {
    if (isCustomerFormLoading) return;

    const clickToPayMessage = document.getElementById('hst_disclaimer_span');
    if (clickToPayMessage) clickToPayMessage.style.display = 'none';

    setPaymentMethod(null);
    setSelectedDigitalWallet(null);
    setPaymentWithClickToPay(false);
  };

  return { selectedMethod, clearSelection };
}
